<template>
  <div>
    <AchievementsHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">优质项目</a-breadcrumb-item>
        <a-breadcrumb-item>{{ detail.projectName }}详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="logo">
        <img v-if="detail.picture" style="width: 100%;height: 100%;" :src="getImg(detail.picture)" />
        <img v-else src="@/assets/img/defaultImg.png" alt="">
      </div>
      <div class="rightBox">
        <div class="tankName">{{ detail.projectName }}</div>
        <div class="infoBox">
          <a-descriptions :column="2">
            <a-descriptions-item label="推荐单位">{{ detail.companyName }}</a-descriptions-item>
            <a-descriptions-item label="负责人">{{ detail.projectLinkman }}</a-descriptions-item>
            <a-descriptions-item label="技术领域">
              <dict-render :dict-obj="dictObjs['research_field']" v-if="detail.researchField"
                :text="detail.researchField"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="联系电话">{{ detail.phone }}</a-descriptions-item>
          </a-descriptions>
          <div class="grayBox" v-if="isUserCode">
            <a-button style="background-color: #fc550b;color: #fff;" @click="onPass()">联系项目方</a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            项目介绍
          </div>
        </div>
        <div class="talentContentBox">
          {{ detail.projectView }}
        </div>
      </div>
    </div>
    <LayoutFooter />
    <CorpProjectModal ref="corpProjectModal" :form-primary-key-field="listKeyField" @finish="onClose" />
  </div>
</template>
<script>
import { tableListMixin, dictMixin } from "@/mixins";
import AchievementsHeader from './achievementsHeader';
import { achievementFontInfo } from "@/api/achievementsService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import { message } from "ant-design-vue";
import CorpProjectModal from "./corpProjectModal";

export default {
  name: "noticeDetail",
  components: { AchievementsHeader, DictRender, LayoutFooter, CorpProjectModal },
  mixins: [tableListMixin, dictMixin],
  data() {
    return {
      dictNames: 'research_field',
      companyJobList: {},
      detail: {},
      ellipsis: true,
      isUserCode: false
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: achievementFontInfo.projectDetail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.detail = res
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/achievements/components/corpProject",
        query: { type: '优质项目' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/achievements/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    },
    onPass() {
      if (this.isUserCode) {
        let obj = {
          ...this.detail,
          functionId: this.detail.id,
        }
        this.onShowModal('corpProjectModal', obj)
      } else {
        message.success("请登录后操作！")
      }
    }
  },
  mounted() {
    this.getDetail()
    this.isUserCode = this.$ls.get("roleCode").includes('user') || this.$ls.get("roleCode").includes('company')
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  // background: white;
}

.tutorBox {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .logo {
    float: left;
    width: 100px;
    height: 100px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .rightBox {
    width: 90%;
    float: left;
    margin-left: 15px;

    .tankName {
      margin-bottom: 18px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }

    .infoBox {
      position: relative;
      padding: 20px;
      background-color: #ecf0f6;
      margin-bottom: 15px;
      font-size: 14px;
      color: #666;

      .grayBox {
        position: absolute;
        right: 5%;
        bottom: 30%;
      }
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;
  background-color: #fff;

  .talentLeftBox {
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }
    }

    .talentContentBox {
      padding: 14px 20px;
      width: 100%;
      text-indent: 2em;
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #333;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #333;
}
</style>
